import classNames from 'classnames'
import * as React from 'react'

import './Style.scss'

type Spacings = 0 | 5 | 10 | 15 | 20 | 40

function handleClock(prefix: string, arr: Spacings[]) {
  const clock = ['top', 'right', 'bottom', 'left']
  const output = []
  for (let i = 0; i < 4; i++) {
    if (arr[i]) {
      output.push(`${prefix}-${clock[i]}-${arr[i]}`)
    }
  }
  return output
}

function handleDoubleArray(prefix: string, arr: Spacings[][]) {
  const output: string[] = []
  if (arr.length > 0) {
    output.push.apply(output, handleClock(`mobile-${prefix}`, arr[0]))
  }
  if (arr.length > 1) {
    output.push.apply(output, handleClock(`tablet-${prefix}`, arr[1]))
  }
  if (arr.length > 2) {
    output.push.apply(output, handleClock(`desktop-${prefix}`, arr[2]))
  }
  return output
}

function handleSingleArray(prefix: string, arr: Spacings[]) {
  return [
    arr.length > 0 ? `mobile-${prefix}-${arr[0]}` : null,
    arr.length > 1 ? `tablet-${prefix}-${arr[1]}` : null,
    arr.length > 2 ? `desktop-${prefix}-${arr[2]}` : null,
  ]
}

function getPropsFromArray(
  prefix: string,
  array?: Array<Spacings | Spacings[]>,
) {
  if (array && array.length > 0) {
    const firstElement = array[0]
    if (typeof firstElement === 'number') {
      return handleSingleArray(prefix, array as Spacings[])
    } else {
      return handleDoubleArray(prefix, array as Spacings[][])
    }
  }
  return []
}

interface StyleProps {
  padding?: Array<Spacings | Spacings[]>
  margin?: Array<Spacings | Spacings[]>
  children?: React.ReactNode | undefined
}

const Style: React.FC<StyleProps> = props => {
  const padding = getPropsFromArray('padding', props.padding)
  const margin = getPropsFromArray('margin', props.margin)
  const styleClasses = classNames('srprs-style', ...padding, ...margin)
  return <div className={styleClasses}>{props.children}</div>
}

export default Style
